export const file = {
  data: {
    title: 'Hottest deals right now',
    subtitle: 'Our latest deals',
    content: {
      content: {
        total_pages: 2,
        total_posts: 13,
        current_page: 1,
        posts_per_page: 10,
        posts: [
          {
            id: 76,
            title: 'product',
            url: 'https://clearbuy.com/admin/product?id=14&backUrl=https%3A%2F%2Fclearbuy.com%2Fadmin%2Fproducts%3Fpage%3D17',
            if_free: null,
            store: 'test agent',
            added: 'Added June 17, 2022',
            expires: '',
            expired: false,
            original_price: 8,
            current_price: 5,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: null,
            image: null,
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=76&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 75,
            title: 'product',
            url: 'https://clearbuy.com/admin/product?id=14&backUrl=https%3A%2F%2Fclearbuy.com%2Fadmin%2Fproducts%3Fpage%3D17',
            if_free: null,
            store: 'test agent',
            added: 'Added June 17, 2022',
            expires: '',
            expired: false,
            original_price: 11,
            current_price: 10,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: null,
            image: null,
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=75&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 74,
            title: 'product',
            url: 'https://clearbuy.com/admin/product?id=14&backUrl=https%3A%2F%2Fclearbuy.com%2Fadmin%2Fproducts%3Fpage%3D17',
            if_free: null,
            store: 'test agent',
            added: 'Added June 17, 2022',
            expires: '',
            expired: false,
            original_price: 6,
            current_price: 5,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: null,
            image: null,
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=74&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 55,
            title: 'Super NEW',
            url: 'http://some',
            if_free: null,
            store: 'Best Buy',
            added: 'Added May 26, 2022',
            expires: '',
            expired: false,
            original_price: 45,
            current_price: 44,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: null,
            image: null,
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=55&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 50,
            title: 'Super NEW',
            url: 'http://some',
            if_free: null,
            store: 'Best Buy',
            added: 'Added May 26, 2022',
            expires: '',
            expired: false,
            original_price: 42,
            current_price: 37,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: null,
            image: null,
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=50&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 71,
            title: 'product best',
            url: 'https://clearbuy.com/admin/product?id=14&backUrl=https%3A%2F%2Fclearbuy.com%2Fadmin%2Fproducts%3Fpage%3D17',
            if_free: null,
            store: 'Amazon',
            added: 'Added May 11, 2022',
            expires: '',
            expired: false,
            original_price: 6,
            current_price: 5,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: 'custom text',
            image:
              'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/%D0%91%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.jfif',
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=71&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 70,
            title: 'product best',
            url: 'https://clearbuy.com/admin/product?id=14&backUrl=https%3A%2F%2Fclearbuy.com%2Fadmin%2Fproducts%3Fpage%3D17',
            if_free: null,
            store: 'Amazon',
            added: 'Added May 11, 2022',
            expires: '',
            expired: false,
            original_price: 6,
            current_price: 5,
            currency: '$',
            summary: null,
            coupon_code: null,
            retailer_custom_text: null,
            image:
              'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/%D0%91%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.jfif',
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=70&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 78,
            title: 'New Test 2',
            url: 'https://soundcloud.com/walther-emil-eriksen/wisdom-beautiful-chillstep-mix',
            if_free: null,
            store: 'test agent',
            added: 'Added March 23, 2022',
            expires: '2 days remaining | ',
            expired: false,
            original_price: null,
            current_price: 4.4,
            currency: '$',
            summary: 'Product summary',
            coupon_code: 'SDJFH45',
            retailer_custom_text: 'Retailer custom text',
            image:
              'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/%D0%91%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.jfif',
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=78&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 58,
            title:
              '2021 Apple MacBook Pro (14-inch, Apple M1 Pro chip with 8\u2011core CPU and 14\u2011core GPU, 16GB RAM, 512GB SSD) - Space Gray',
            url: 'https://dev.clearbuy.com/admin/product?id=1693&backUrl=https%3A%2F%2Fdev.clearbuy.com%2Fadmin%2Fproducts',
            if_free: null,
            store: 'Amazon',
            added: 'Added March 3, 2022',
            expires: '',
            expired: false,
            original_price: 6,
            current_price: 5,
            currency: '$',
            summary:
              'Apple M1 Pro or M1 Max chip for a massive leap in CPU, GPU, and machine learning performance\nUp to 10-core CPU delivers up to 3.7x faster performance to fly through pro workflows quicker than ever\nUp to 32-core GPU with up to 13x faster performance for graphics-intensive apps and games\n16-core Neural Engine for up to 11x faster machine learning performance\nLonger battery life, up to 17 hours\nUp to 64GB of unified memory so everything you do is fast and fluid\nUp to 8TB of superfast SSD storage launches apps and opens files in an instant\nStunning 14-inch Liquid Retina XDR display with extreme dynamic range and contrast ratio\n1080p FaceTime HD camera with advanced image signal processor for sharper video calls\nSix-speaker sound system with force-cancelling woofers',
            coupon_code: null,
            retailer_custom_text: null,
            image:
              'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/B09JQSLL92/3187i1nSVTL._SL500_.jpg',
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=58&backUrl=%2Fadmin%2Fdeals',
          },
          {
            id: 57,
            title:
              '2021 Apple MacBook Pro (14-inch, Apple M1 Pro chip with 8\u2011core CPU and 14\u2011core GPU, 16GB RAM, 512GB SSD) - Space Gray',
            url: 'https://dev.clearbuy.com/admin/product?id=1693&backUrl=https%3A%2F%2Fdev.clearbuy.com%2Fadmin%2Fproducts',
            if_free: null,
            store: 'Amazon',
            added: 'Added March 3, 2022',
            expires: '',
            expired: false,
            original_price: 6,
            current_price: 5,
            currency: '$',
            summary:
              'Apple M1 Pro or M1 Max chip for a massive leap in CPU, GPU, and machine learning performance\nUp to 10-core CPU delivers up to 3.7x faster performance to fly through pro workflows quicker than ever\nUp to 32-core GPU with up to 13x faster performance for graphics-intensive apps and games\n16-core Neural Engine for up to 11x faster machine learning performance\nLonger battery life, up to 17 hours\nUp to 64GB of unified memory so everything you do is fast and fluid\nUp to 8TB of superfast SSD storage launches apps and opens files in an instant\nStunning 14-inch Liquid Retina XDR display with extreme dynamic range and contrast ratio\n1080p FaceTime HD camera with advanced image signal processor for sharper video calls\nSix-speaker sound system with force-cancelling woofers',
            coupon_code: null,
            retailer_custom_text: null,
            image:
              'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/B09JQSLL92/3187i1nSVTL._SL500_.jpg',
            edit_url: 'https://dev.clearbuy.com/admin/deal?id=57&backUrl=%2Fadmin%2Fdeals',
          },
        ],
      },
      hot: [
        {
          id: 53,
          title: 'Traktor test',
          url: 'https://exmple.com',
          if_free: null,
          store: 'Best Buy',
          added: 'Added 0 s',
          expires: '10 days remaining | ',
          expired: false,
          original_price: 23,
          current_price: 22,
          currency: '$',
          summary: 'Summary',
          coupon_code: null,
          retailer_custom_text: null,
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/%D0%91%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.jfif',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=53&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 67,
          title: 'Traktor test',
          url: 'https://exmple.com',
          if_free: null,
          store: 'Amazon',
          added: 'Added 0 s',
          expires: '10 days remaining | ',
          expired: false,
          original_price: 32,
          current_price: 8,
          currency: '$',
          summary: 'Summary',
          coupon_code: 'Some text',
          retailer_custom_text: 'Some custom text',
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/%D0%91%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.jfif',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=67&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 52,
          title: 'Super NEW',
          url: 'http://some',
          if_free: null,
          store: 'Best Buy',
          added: 'Added May 26, 2022',
          expires: '',
          expired: false,
          original_price: 15,
          current_price: 10,
          currency: '$',
          summary: null,
          coupon_code: null,
          retailer_custom_text: null,
          image: null,
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=52&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 59,
          title:
            '2021 Apple MacBook Pro (14-inch, Apple M1 Pro chip with 8\u2011core CPU and 14\u2011core GPU, 16GB RAM, 512GB SSD) - Space Gray',
          url: 'https://dev.clearbuy.com/admin/product?id=1693&backUrl=https%3A%2F%2Fdev.clearbuy.com%2Fadmin%2Fproducts',
          if_free: null,
          store: 'Amazon',
          added: 'Added March 3, 2022',
          expires: '8 days remaining | ',
          expired: false,
          original_price: 6,
          current_price: 5,
          currency: '$',
          summary:
            'Apple M1 Pro or M1 Max chip for a massive leap in CPU, GPU, and machine learning performance\nUp to 10-core CPU delivers up to 3.7x faster performance to fly through pro workflows quicker than ever\nUp to 32-core GPU with up to 13x faster performance for graphics-intensive apps and games\n16-core Neural Engine for up to 11x faster machine learning performance\nLonger battery life, up to 17 hours\nUp to 64GB of unified memory so everything you do is fast and fluid\nUp to 8TB of superfast SSD storage launches apps and opens files in an instant\nStunning 14-inch Liquid Retina XDR display with extreme dynamic range and contrast ratio\n1080p FaceTime HD camera with advanced image signal processor for sharper video calls\nSix-speaker sound system with force-cancelling woofers',
          coupon_code: null,
          retailer_custom_text: null,
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/B09JQSLL92/3187i1nSVTL._SL500_.jpg',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=59&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 56,
          title:
            '2021 Apple MacBook Pro (14-inch, Apple M1 Pro chip with 8\u2011core CPU and 14\u2011core GPU, 16GB RAM, 512GB SSD) - Space Gray',
          url: 'https://dev.clearbuy.com/admin/product?id=1693&backUrl=https%3A%2F%2Fdev.clearbuy.com%2Fadmin%2Fproducts',
          if_free: null,
          store: 'Amazon',
          added: 'Added March 3, 2022',
          expires: '8 days remaining | ',
          expired: false,
          original_price: 6,
          current_price: 5,
          currency: '$',
          summary:
            'Apple M1 Pro or M1 Max chip for a massive leap in CPU, GPU, and machine learning performance\nUp to 10-core CPU delivers up to 3.7x faster performance to fly through pro workflows quicker than ever\nUp to 32-core GPU with up to 13x faster performance for graphics-intensive apps and games\n16-core Neural Engine for up to 11x faster machine learning performance\nLonger battery life, up to 17 hours\nUp to 64GB of unified memory so everything you do is fast and fluid\nUp to 8TB of superfast SSD storage launches apps and opens files in an instant\nStunning 14-inch Liquid Retina XDR display with extreme dynamic range and contrast ratio\n1080p FaceTime HD camera with advanced image signal processor for sharper video calls\nSix-speaker sound system with force-cancelling woofers',
          coupon_code: null,
          retailer_custom_text: null,
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/B09JQSLL92/3187i1nSVTL._SL500_.jpg',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=56&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 60,
          title: '2020 Apple MacBook Pro with Apple M1 Chip',
          url: 'https://soundcloud.com/walther-emil-eriksen/wisdom-beautiful-chillstep-mix',
          if_free: null,
          store: 'test agent',
          added: 'Added September 10, 2020',
          expires: '',
          expired: false,
          original_price: null,
          current_price: 4.4,
          currency: '$',
          summary:
            'The Apple M1 chip is the first system on a chip (SoC) for Mac. Packed with an astonishing 16 billion transistors, it integrates the CPU, GPU, I/O, and every other significant component and controller onto a single tiny chip. Designed by Apple, M1 brings incredible performance, custom technologies, and unparalleled power efficiency to the Mac.With an 8\u2011core CPU and 8\u2011core GPU, M1 on MacBook Pro delivers up to 2.8x faster CPU performance\u00b9 and up to 5x faster graphics\u00b2 than the previous generation.',
          coupon_code: null,
          retailer_custom_text: null,
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/B08N5LH3F7/71gD8WdSlaL._AC_SL1500_.jpg',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=60&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 26,
          title: '1MORE Colorbuds Wireless Earbuds',
          url: 'https://www.amazon.com/',
          if_free: null,
          store: 'test agent',
          added: 'Added June 24, 2020',
          expires: '',
          expired: false,
          original_price: null,
          current_price: 31,
          currency: '$',
          summary:
            'Enjoy a lightweight and compact design with a portable charging case that easily fits in your pocket for improved mobility. Each earphone weighs only 4.1g, you will even forget that you are wearing the headphones.',
          coupon_code: null,
          retailer_custom_text: null,
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/B08BRNQV3X/51MtRnZwmWL._AC_SL1500_.jpg',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=26&backUrl=%2Fadmin%2Fdeals',
        },
        {
          id: 65,
          title: 'New test by Michel',
          url: 'http://some',
          if_free: null,
          store: 'test agent',
          added: 'Added 0 s',
          expires: '',
          expired: false,
          original_price: 12,
          current_price: 11,
          currency: '$',
          summary: null,
          coupon_code: 'very',
          retailer_custom_text: 'aaaaaaaa',
          image:
            'https://clearbuy-staging-cloud.nyc3.digitaloceanspaces.com/products/spongebob.jpg',
          edit_url: 'https://dev.clearbuy.com/admin/deal?id=65&backUrl=%2Fadmin%2Fdeals',
        },
      ],
    },
  },
} as const
